// extracted by mini-css-extract-plugin
export default {"wrapper":"roles_wrapper__e+MQP","Table":"roles_Table__+2lWj","Action-btns":"roles_Action-btns__ebRHC"};